import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DownloadTemplateSheetConfig } from '../../models/template-column-config';
import { ExcelService } from '../../services/excel.service';

@Component({
  selector: 'app-download-template',
  templateUrl: './download-template.component.html',
  styleUrls: ['./download-template.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class DownloadTemplateComponent {
  @Input() sheets: DownloadTemplateSheetConfig[] = [];
  @Input() filename: string = 'template.xlsx';
  @Input() allQuestions: any[] = [];

  constructor(private excelService: ExcelService) {}

  downloadTemplate(): void {
    const workbookData = this.sheets.map((sheet) => ({
      workSheet: sheet.name,
      columns: sheet.columns,
      rows: sheet.rows,
      dropdowns: sheet.dropdowns,
    }));
    this.excelService.exportAsExcelFile(workbookData, this.filename, this.allQuestions);
  }
}
